import './session-end.scss';

import { useEndSession } from '~pages/manager/SessionEnd/use-end-session.ts';
import { PhotoMake, PhotoPreview, Preloader } from '~shared/ui';

type SessionEndProps = {
	userId: string;
};

export function SessionEnd({ userId }: SessionEndProps) {
	const { pending, photo, clear, setPhoto, end } = useEndSession(userId);

	return (
		<div className="session-end">
			{pending ? (
				<Preloader />
			) : (
				<div className="row">
					{photo ? (
						<PhotoPreview photo={photo} onClear={clear} onCreate={end} />
					) : (
						<PhotoMake onCreate={setPhoto} />
					)}
				</div>
			)}
		</div>
	);
}
